export default __webpack_public_path__ + "static/hero-image-8-38f1bc5d885fd12480f811b9e5991d9b.jpeg";